import { Input } from 'antd'
import { FilterDropdownProps } from 'antd/lib/table/interface'
import { ElementRef, useEffect, useRef, useState } from 'react'
import ColumnFilterWrapper from './ColumnFilterWrapper'

const ColumnSearch: React.FC<FilterDropdownProps> = ({
  visible,
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
}) => {
  const onSearch = (keys: React.Key[], confirm: () => void) => {
    confirm()
    setSearchValue(keys[0] as string)
  }
  const [, setSearchValue] = useState<string>()
  const input = useRef<ElementRef<typeof Input> | null>(null)
  useEffect(() => {
    if (visible) setTimeout(() => input.current?.select?.(), 100)
  }, [visible])
  return (
    <ColumnFilterWrapper
      confirm={confirm}
      clearFilters={clearFilters}
      onOk={() => {
        setSearchValue(selectedKeys[0]?.toString())
      }}
      onReset={() => {
        setSearchValue(undefined)
      }}
      selectedKeys={selectedKeys}
    >
      <Input
        ref={input}
        value={selectedKeys[0]}
        onChange={({ target: { value } }) =>
          setSelectedKeys(value ? [value] : [])
        }
        onPressEnter={() => onSearch(selectedKeys, confirm)}
      />
    </ColumnFilterWrapper>
  )
}

export default ColumnSearch
